import React, { useState } from 'react';
import "./News.css"; 


import News_image_1 from './NewsPhotos/WhatsApp Image 2023-10-31 at 13.45.39.jpeg'; 
import News_image_2 from './NewsPhotos/WhatsApp Image 2023-10-31 at 13.47.44.jpeg'; 
import News_image_3 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.25 (1).jpeg'; 
import News_image_4 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.25.jpeg'; 
import News_image_5 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.26 (1).jpeg'; 
import News_image_6 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.26 (2).jpeg'; 
import News_image_7 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.28.jpeg'; 
import News_image_8 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.29 (1).jpeg'; 
import News_image_9 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.29.jpeg'; 
import News_image_10 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.30 (1) (1).jpeg'; 
import News_image_11 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.30 (2).jpeg'; 
import News_image_12 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.30.jpeg'; 
import News_image_13 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.31.jpeg'; 
import News_image_14 from './NewsPhotos/WhatsApp Image 2023-10-31 at 14.07.33.jpeg'; 
import News_image_15 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.11.jpeg'; 
import News_image_16 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.12.jpeg'; 
import News_image_17 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.15.jpeg'; 
import News_image_18 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.19 (1).jpeg'; 
import News_image_19 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.19 (2).jpeg'; 
import News_image_20 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.20 (1).jpeg'; 
import News_image_21 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.20.jpeg'; 
import News_image_22 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.21 (1).jpeg'; 
import News_image_23 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.21.jpeg'; 
import News_image_24 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.22 (1).jpeg'; 
import News_image_25 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.22 (2).jpeg'; 
import News_image_26 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.24 (1).jpeg'; 
import News_image_27 from './NewsPhotos/WhatsApp Image 2023-10-31 at 15.37.24.jpeg'; 
import News_image_28 from './NewsPhotos/WhatsApp Image 2025-01-27 at 11.15.34.jpeg';  

 

const News = () => {
  const images = [
    News_image_1, News_image_2, News_image_3, News_image_4, News_image_5, News_image_6, 
    News_image_7, News_image_8, News_image_9, News_image_10, News_image_11, News_image_12, News_image_13, News_image_14,News_image_15,News_image_16, News_image_17, News_image_18, News_image_19, News_image_20, News_image_21, News_image_22, News_image_23,News_image_24,News_image_25,News_image_26,News_image_27,News_image_28];

  const [zoomedImage, setZoomedImage] = useState(null);

  const handleZoom = (image) => {
    if (zoomedImage === image) {
      setZoomedImage(null); 
    } else {
      setZoomedImage(image);     
    }
  };

  const handleBack = () => {
    setZoomedImage(null); 
  };

  return (
    <div className="news-main-container">
      <div className={`images-gallery ${zoomedImage ? 'zoomed-gallery' : ''}`}>
        {images.map((image, index) => (
          <div className="image-gallery1" key={index}>
            <img 
              src={image} 
              className={`Gallery_image_1 ${zoomedImage === image ? 'zoomed' : ''}`} 
              alt={`gallery-img-${index}`} 
              onClick={() => handleZoom(image)} 
              style={{ height: '300px', width: '300px' }}
            />
          </div>
        ))}
      </div>

      {zoomedImage && (
        <div className="zoomed-image-container">
          <img
            src={zoomedImage}
            alt="Zoomed Full View"
            className="zoomed-image"
            style={{ height: '500px', width: '800px' }}
          />
          <button className="back-button" onClick={handleBack}>
            Back to News
          </button>
        </div>
      )}
    </div>
  );
};

export default News;

